var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestACallback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 49,
    viewBox: "0 0 45 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.2154 24.3371V14.1662C43.2154 12.4998 41.8646 11.149 40.1982 11.149H25.9395",
    stroke: "white",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2344 2L28.0847 9.22454C26.9037 10.418 26.9241 12.346 28.1301 13.5142L35.2344 20.3953",
    stroke: "white",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.477 13.4347L10.3043 6.29723C9.54056 5.53721 8.30636 5.54121 7.55326 6.31181C6.0718 7.82768 3.73458 10.2412 2.35053 11.7815C0.0707386 14.3188 9.3081 28.035 14.7097 33.1453C20.1113 38.2556 34.0995 49.5489 37.2403 46.4795C38.6322 45.1192 41.0728 42.7101 42.6106 41.1906C43.3794 40.4309 43.3803 39.1912 42.6141 38.4287L35.8676 31.7148C35.1173 30.9681 33.9086 30.9574 33.1488 31.6943C32.4633 32.3591 31.6305 33.1704 30.9208 33.8724C30.6014 34.1884 30.1853 34.4041 29.741 34.3372C25.2111 33.6552 15.4725 23.4757 14.739 19.623C14.6605 19.2105 14.8702 18.8237 15.1664 18.5261C15.9097 17.7793 16.7825 16.8959 17.4916 16.1766C18.2428 15.4146 18.2355 14.1895 17.477 13.4347Z",
    stroke: "white",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestACallback);
export default __webpack_public_path__ + "static/media/request-a-callback.619b8722fc4cce4828a2836276107bba.svg";
export { ForwardRef as ReactComponent };